import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'

export enum QueryRootFeatureIdEnum {
  ROOT_QUERY = 'query',
}

export enum FeedbackFeatureIdEnum {
  FEEDBACK = 'feedback',
}

export enum HighlightsFeatureIdEnum {
  HIGHLIGHTS = 'highlights',
}

export enum InnovationsFeatureIdEnum {
  INNOVATIONS = 'innovations',
}

export enum InsightsFeatureIdEnum {
  INSIGHTS = 'insights',
  NOW = 'now',
  ORIGINS = 'origins',
  KEYWORDS = 'keywords',
  CATEGORIES = 'categories',
  OPPORTUNITIES = 'opportunities',
  OVERALL = 'overall',
  QUERIES = 'queries',
  CONVERSATIONAL = 'conversational',
  SEMANTICS = 'semantics',
  RELATED_PROMPTS_ANALYTICS = 'relatedPromptsAnalytics',
}

export enum PlayRootFeatureIdEnum {
  PLAY = 'play',
}

export enum RelatedPromptsFeatureIdEnum {
  RELATED_PROMPTS = 'relatedPrompts',
}

export const PlayFeatureIdEnum = {
  ...PlayRootFeatureIdEnum,
  ...ActionTypeEnum,
  ...RelatedPromptsFeatureIdEnum,
}

export type PlayFeatureIdEnum = PlayRootFeatureIdEnum | ActionTypeEnum | RelatedPromptsFeatureIdEnum

export enum ExplainFeatureIdEnum {
  EXPLAIN = 'explain',
}

export enum AuditFeatureIdEnum {
  AUDIT = 'audit',
}

export enum IndexFeatureIdEnum {
  INDEX = 'index',
}

export enum UserRoleManagementFeatureIdEnum {
  USER_ROLE_MANAGEMENT = 'userRoleManagement',
}

export enum ToolReportingFeatureIdEnum {
  TOOL_REPORTING = 'toolReporting',
}

export enum InstanceManagementFeatureIdEnum {
  INSTANCE_MANAGEMENT = 'instanceManagement',
}

export enum ClientConfigFeatureIdEnum {
  CLIENT_CONFIG = 'clientConfig',
}

export enum EndpointConfigFeatureIdEnum {
  ENDPOINT_CONFIG = 'endpointConfig',
}

export enum FeatureConfigFeatureIdEnum {
  FEATURE_CONFIG = 'featureConfig',
}

export enum IndexClientFeatureIdEnum {
  INDEX_CLIENT = 'indexClient',
}

export enum IndexFeedConfigurationFeatureIdEnum {
  INDEX_FEED_CONFIGURATION = 'indexFeedConfiguration',
}

export enum IndexSchemaConfigurationFeatureIdEnum {
  INDEX_SCHEMA_CONFIGURATION = 'indexSchemaConfiguration',
}

export enum AccountFeatureIdEnum {
  ACCOUNT = 'account',
}

export enum CreateInstanceFeatureIdEnum {
  CREATE_INSTANCE = 'createInstance',
}

export enum BrowseFeatureIdEnum {
  BROWSE = 'browse',
}

export enum FacetsFeatureIdEnum {
  FACETS = 'facets',
}

export enum CurationToolsFeatureIdEnum {
  CURATION_TOOLS = 'curationTools',
}

export const FeatureIdEnum = {
  ...ClientConfigFeatureIdEnum,
  ...EndpointConfigFeatureIdEnum,
  ...FeatureConfigFeatureIdEnum,
  ...IndexClientFeatureIdEnum,
  ...IndexFeedConfigurationFeatureIdEnum,
  ...IndexSchemaConfigurationFeatureIdEnum,
  ...FeedbackFeatureIdEnum,
  ...HighlightsFeatureIdEnum,
  ...InsightsFeatureIdEnum,
  ...PlayFeatureIdEnum,
  ...ExplainFeatureIdEnum,
  ...AuditFeatureIdEnum,
  ...IndexFeatureIdEnum,
  ...UserRoleManagementFeatureIdEnum,
  ...InstanceManagementFeatureIdEnum,
  ...AccountFeatureIdEnum,
  ...CreateInstanceFeatureIdEnum,
  ...ToolReportingFeatureIdEnum,
  ...QueryRootFeatureIdEnum,
  ...BrowseFeatureIdEnum,
  ...FacetsFeatureIdEnum,
  ...InnovationsFeatureIdEnum,
  ...CurationToolsFeatureIdEnum,
}
export type FeatureIdEnum =
  | ClientConfigFeatureIdEnum
  | EndpointConfigFeatureIdEnum
  | FeatureConfigFeatureIdEnum
  | IndexClientFeatureIdEnum
  | IndexFeedConfigurationFeatureIdEnum
  | IndexSchemaConfigurationFeatureIdEnum
  | FeedbackFeatureIdEnum
  | HighlightsFeatureIdEnum
  | InsightsFeatureIdEnum
  | PlayFeatureIdEnum
  | ExplainFeatureIdEnum
  | AuditFeatureIdEnum
  | IndexFeatureIdEnum
  | UserRoleManagementFeatureIdEnum
  | InstanceManagementFeatureIdEnum
  | AccountFeatureIdEnum
  | CreateInstanceFeatureIdEnum
  | ToolReportingFeatureIdEnum
  | QueryRootFeatureIdEnum
  | BrowseFeatureIdEnum
  | FacetsFeatureIdEnum
  | InnovationsFeatureIdEnum
  | CurationToolsFeatureIdEnum
